/* @flow */

import * as types from './supportActionTypes';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import { supportContactEndpoint } from 'src/shared/app/base/settings/endpointSettings';

export function sendSupportEmail(
  userFirstName: string,
  userLastName: string,
  userEmail: string,
  eventId: number,
  userAgent: string,
  values: Object,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(sendSupportEmailRequest());

    const { support_type: type, message, image } = values;

    const data = new FormData();

    data.append('first_name', userFirstName);
    data.append('last_name', userLastName);
    data.append('email', userEmail);
    data.append('support_type', type);
    data.append('user_agent', userAgent);
    data.append('message', message);

    if (image) {
      data.append('screenshot', image);
    }

    return post(supportContactEndpoint(eventId), data)
      .then(parseResponse)
      .then(() => dispatch(sendSupportEmailSuccess()))
      .catch((exception) => {
        dispatch(sendSupportEmailFailure(exception));
        throw exception;
      });
  };
}

export function sendSupportEmailRequest(): Object {
  return {
    type: types.SEND_SUPPORT_REQUEST,
  };
}

export function sendSupportEmailSuccess(): Object {
  return {
    type: types.SEND_SUPPORT_SUCCESS,
  };
}

export function sendSupportEmailFailure(exception: Error): Object {
  return {
    type: types.SEND_SUPPORT_FAILURE,
    exception,
  };
}
